module.exports = __webpack_public_path__ + "img/perfectpay.011bcf1f.png";